class FooterSignup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then(res => {
      const countryCode = res.detected_values.country.handle

      if (
        countryCode === 'GB' &&
        this?.els?.attentive?.exists &&
        this?.els?.iframe?.exists &&
        this?.els?.original?.exists
      ) {
        const gbIframe = this?.dataset?.uk

        if (gbIframe) {
          this.els.iframe.element.src = gbIframe

          this.els.original.element.style.display = 'none'
          this.els.attentive.element.style.display = 'block'
        }
      }

      if (
        countryCode === 'US' &&
        this?.els?.attentive?.exists &&
        this?.els?.iframe?.exists &&
        this?.els?.original?.exists
      ) {
        const usIframe = this?.dataset?.us

        if (usIframe) {
          this.els.iframe.element.src = usIframe

          this.els.original.element.style.display = 'none'
          this.els.attentive.element.style.display = 'block'
        }
      }
    })
  }
}

if (!customElements.get('footer-signup')) {
  customElements.define('footer-signup', FooterSignup)
}
